import type ApiUrlCreator from "@core-ui/ApiServices/ApiUrlCreator";
import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import { type CatalogLogo, findCatalogLogo } from "@core-ui/ContextServices/CatalogLogoService/catalogLogoHooks";
import Workspace from "@core-ui/ContextServices/Workspace";
import { useSetting } from "@ext/settings/logic/hooks";
import type Theme from "@ext/Theme/Theme";
import fetchLogoImage from "./fetchLogoImage";
import useCachedLogo, { type CatalogLogoSource } from "./useCachedLogo";

const fetchLoadedCatalogLogo = async (
	apiUrlCreator: ApiUrlCreator,
	catalogName: string,
	theme: Theme,
): Promise<CatalogLogoSource | null> => {
	const found = await findCatalogLogo(apiUrlCreator, catalogName, theme);
	if (!found) return null;
	return "url" in found ? fetchLogoImage(found.url) : found;
};

const useLoadedCatalogLogo = (catalogName: string | undefined): CatalogLogo | null => {
	const apiUrlCreator = ApiUrlCreatorService.value;
	const workspacePath = Workspace.current()?.path;
	const [theme] = useSetting("general.theme");
	const key = catalogName ? JSON.stringify(["loaded", workspacePath, catalogName, theme]) : null;

	return useCachedLogo(key, () => fetchLoadedCatalogLogo(apiUrlCreator, catalogName, theme));
};

export default useLoadedCatalogLogo;
